import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  responseVariables: {},
};

const responseVariableSlice = createSlice({
  name: "responseVariables",
  initialState,
  reducers: {
    setResponseVariables: (state, action) => {
      state.responseVariables = action.payload;
    },
    clearResponseVariables: (state) => {
      state.responseVariables = {};
    },
  },
});

export const { setResponseVariables, clearResponseVariables } =
  responseVariableSlice.actions;
export default responseVariableSlice.reducer;
